export enum AboutRoutes {
  BasePrefix = "about",
  GetBuildVersion = "version"
}
